import Vue from "vue";
import axios from "axios";
import { Message } from "iview";
import Cookie from "js-cookie";
let _baseUrl = "";
let service = null;

const VUE_APP_ENV = 'test';

export default ({ app }) => {
  let CancelToken = axios.CancelToken;
  //设置默认请求头，如果不需要可以取消这一步
  console.log(process.env);
  switch (VUE_APP_ENV) {
    case 'development':
      _baseUrl = "http://192.168.200.125:9091/"  //这里是本地的请求url
      break
    case 'test':   // 注意这里的名字要和设置的模式名字对应起来
      _baseUrl = "https://test-crm.bnyc.com/api/"  //这里是测试环境中的url
      break
    case 'uat':   // 注意这里的名字要和设置的模式名字对应起来
      _baseUrl = "https://uat-crm.bnyc.com/api/"  //这里是UAT环境中的url
      break
    case 'production':
      _baseUrl = "https://crm.bnyc.com/api/"   //生产环境url
      break
  }

  service = axios.create({
    baseURL: _baseUrl
  });

  // 请求超时的时间限制
  service.defaults.timeout = 600000;
  // 开始设置请求 发起的拦截处理

  // config 代表发起请求的参数的实体
  service.interceptors.request.use(
    config => {
      let token = Cookie.get("token");
      if (token) {
        config.headers["Access-Token"] = token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // 请求到结果的拦截处理
  service.interceptors.response.use(
    response => {
      let data = response.data;
      // 返回请求正确的结果
      if (data instanceof Blob) {
        return data;
      }
      if (data.status == 200) {
        if (data.result) {
          findArray(data.result)
        }
        return data.result;

      } else if (data.status == 20101) {
        Cookie.remove("token");
        app.router.push("/login");
      } else if (data.status == 403) {
        app.router.push("/not-permission");
      } else {
        return Promise.reject(data);
      }
    }
    ,
    error => {
      // 错误的请求结果处理，这里的代码根据后台的状态码来决定错误的输出信息
      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            error.message = "错误请求";
            break;
          case 401:
            error.message = "未授权，请重新登录";
            break;
          case 403:
            error.message = "拒绝访问";
            break;
          case 404:
            error.message = "请求错误,未找到该资源";
            break;
          case 405:
            error.message = "请求方法未允许";
            break;
          case 408:
            error.message = "请求超时";
            break;
          case 500:
            if (error.response.data && error.response.data.message) {
              error.message = error.response.data.message;
            } else {
              error.message = "服务器端出错";
            }
            break;
          case 501:
            error.message = "网络未实现";
            break;
          case 502:
            error.message = "网络错误";
            break;
          case 503:
            error.message = "服务不可用";
            break;
          case 504:
            error.message = "网络超时";
            break;
          case 505:
            error.message = "http版本不支持该请求";
            break;
          default:
            error.message = `连接错误${error.response.status}`;
        }
      } else {
        error.message = "连接到服务器失败";
        // Message.error(error.message)
      }
      return Promise.reject(error.message);
    }
  );
  return service;

};

function findArray (obj) {
  if (obj == null || obj == undefined) {
    return obj
  } else if (obj instanceof Array) {
    for (let item of obj) {
      findObject(item)
    }
  } else if (obj.constructor === Object) {
    findObject(obj)
  } else if (typeof (obj) == 'string') {
    if (obj.indexOf("sysapi.bnyc.com") > -1) {
      obj = obj.replace(/^http:\/\/[^/]+/, 'https://sysapi.bnyc.com');
    } else if (obj.indexOf("124.70.106.206:8088") > -1) {
      obj = obj.replace(/^http:\/\/[^/]+/, 'https://fwad.bnyc.com');
    } else if (obj.indexOf("124.70.106.206:8070") > -1) {
      obj = obj.replace(/^http:\/\/[^/]+/, 'https://sysapi.bnyc.com');
    } else if (obj.indexOf("39.107.255.136:8081") > -1) {
      obj = obj.replace(/^http:\/\/[^/]+/, 'https://crm.bnyc.com/api');
    } else if (obj.indexOf("124.70.106.206:9091") > -1) {
      obj = obj.replace(/^http:\/\/[^/]+/, 'https://crm.bnyc.com/api');
    } else if (obj.indexOf("39.107.255.136:8000") > -1) {
      obj = obj.replace(/^http:\/\/[^/]+/, 'https://crm.bnyc.com/seafile');
    }
  } else {
    return obj
  }
}

function findObject (obj) {
  for (let item in obj) {
    if (typeof (obj[item]) == 'string') {
      if (obj[item].indexOf("sysapi.bnyc.com") > -1) {
        obj[item] = obj[item].replace(/^http:\/\/[^/]+/, 'https://sysapi.bnyc.com');
      } else if (obj[item].indexOf("124.70.106.206:8088") > -1) {
        obj[item] = obj[item].replace(/^http:\/\/[^/]+/, 'https://fwad.bnyc.com');
      } else if (obj[item].indexOf("124.70.106.206:8070") > -1) {
        obj[item] = obj[item].replace(/^http:\/\/[^/]+/, 'https://sysapi.bnyc.com');
      } else if (obj[item].indexOf("39.107.255.136:8081") > -1) {
        obj[item] = obj[item].replace(/^http:\/\/[^/]+/, 'https://crm.bnyc.com/api');
      } else if (obj[item].indexOf("124.70.106.206:9091") > -1) {
        obj[item] = obj[item].replace(/^http:\/\/[^/]+/, 'https://crm.bnyc.com/api');
      } else if (obj[item].indexOf("39.107.255.136:8000") > -1) {
        obj[item] = obj[item].replace(/^http:\/\/[^/]+/, 'https://crm.bnyc.com/seafile');
      } else if (obj[item] == null || obj == undefined) {
        continue
      }
      continue
    } else if (obj == null || obj == undefined) {
      continue
    } else {
      findArray(obj[item])
    }
  }
}

//取消请求
export { service as axios, _baseUrl };
